import {createStore, applyMiddleware, combineReducers} from "redux";
import rootReducer from "../reducers/index";
import exportEntriesReducer from "../reducers/exportEntries/exportEntriesReducer";
import playersListReducer from '../reducers/playersList/playersListReducer';
import registrationFormReducer from "../reducers/registrationForm/registrationFormReducer";
import createSagaMiddleware from 'redux-saga';
import rootSaga from "../sagas";

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({exportEntries: exportEntriesReducer, root: rootReducer, playersList: playersListReducer, regForm: registrationFormReducer});
const store = createStore(reducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default store;